import type { ComponentType } from 'react';
import { lazyWithReload } from '@/lib/lazyWithReload';
import type { SectionType } from './types';
import { Hero } from '@/components/sections/Hero';
import { MobileCategoryTiles } from '@/components/sections/MobileCategoryTiles';
import { CategoryNav } from '@/components/sections/CategoryNav';
import { SeoTextSection } from '@/components/sections/SeoTextSection';

/**
 * Baner i kafelki pierwszego ekranu są dostępne także w statycznym HTML-u.
 * Pozostałe sekcje mają osobne chunki, pobierane po zbliżeniu do viewportu.
 */
export const SECTION_REGISTRY: Record<SectionType, ComponentType<any>> = {
  // SectionRenderer omija DeferredSection dla banera i kafelków kategorii.
  hero: Hero,
  todayDeliveryBanner: lazyWithReload(() =>
    import('@/components/sections/TodayDeliveryBanner').then(m => ({ default: m.TodayDeliveryBanner }))),
  mobileCategoryTiles: MobileCategoryTiles,
  categoryNav: CategoryNav,
  popularBouquets: lazyWithReload(() =>
    import('@/components/sections/PopularBouquets').then(m => ({ default: m.PopularBouquets }))),
  mobileOccasions: lazyWithReload(() =>
    import('@/components/sections/MobileOccasions').then(m => ({ default: m.MobileOccasions }))),
  mobileReviews: lazyWithReload(() =>
    import('@/components/sections/MobileReviews').then(m => ({ default: m.MobileReviews }))),
  orderSteps: lazyWithReload(() =>
    import('@/components/sections/OrderSteps').then(m => ({ default: m.OrderSteps }))),
  featuredProducts: lazyWithReload(() =>
    import('@/components/sections/FeaturedProducts').then(m => ({ default: m.FeaturedProducts }))),
  bouquetCreator: lazyWithReload(() =>
    import('@/components/sections/BouquetCreator').then(m => ({ default: m.BouquetCreator }))),
  googleReviews: lazyWithReload(() =>
    import('@/components/sections/GoogleReviews').then(m => ({ default: m.GoogleReviews }))),
  seoTextSection: SeoTextSection,
  footer: lazyWithReload(() =>
    import('@/components/sections/Footer').then(m => ({ default: m.Footer }))),
};
